import React from 'react';
import {
  Avatar,
  Checkbox,
  FormControlLabel,
  List,
  Pagination,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { Plan, User } from '../../hooks/api/user';
import StudentPlanSelect from './StudentPlanSelect';

interface MobileStudentsListProps {
  students: User[];
  totalStudents: number;
  plans: Plan[];
  onStudentClick: (userId: number) => void;
  onPlanChange: (event: SelectChangeEvent, userId: number) => void;
  onSearchChange: (searchText: string) => void;
  onToggleActiveOnly: () => void;
  showActiveOnly: boolean;
  page: number;
  rowsPerPage: number;
  onPageChange: (page: number) => void;
}

export default function MobileStudentsList({
  students,
  totalStudents,
  plans,
  onStudentClick,
  onPlanChange,
  onSearchChange,
  onToggleActiveOnly,
  showActiveOnly,
  page,
  rowsPerPage,
  onPageChange,
}: MobileStudentsListProps) {
  const pageCount = Math.max(1, Math.ceil(totalStudents / rowsPerPage));

  return (
    <div className="students-container">
      <Typography variant="h6" gutterBottom>
        Alumnos ({totalStudents})
      </Typography>
      <TextField
        className="student-searcher"
        label="Busca alumnos"
        variant="outlined"
        size="small"
        onChange={(event) => onSearchChange(event.target.value)}
      />
      <FormControlLabel
        control={<Checkbox checked={showActiveOnly} onChange={onToggleActiveOnly} />}
        label="Solo activos"
      />
      <div className="list-box">
        <List>
          {students.map((user) => (
            <ListItem key={user.id} className="student-item">
              <ListItemAvatar onClick={() => onStudentClick(user.id)}>
                <Avatar alt={user.nickName} src={user.image} sx={{ width: 40, height: 40 }} />
              </ListItemAvatar>
              <ListItemText
                primary={user.nickName ?? `${user.firstName} ${user.lastName}`}
                secondary={`${user.planBookings} clases`}
                onClick={() => onStudentClick(user.id)}
                className="student-text"
              />
              <StudentPlanSelect
                planId={user.plan?.id}
                plans={plans}
                onChange={(event) => onPlanChange(event, user.id)}
              />
            </ListItem>
          ))}
        </List>
      </div>
      {pageCount > 1 && (
        <Stack alignItems="center" sx={{ mt: 2, mb: 10 }}>
          <Pagination
            count={pageCount}
            page={page + 1}
            onChange={(_, nextPage) => onPageChange(nextPage - 1)}
            color="primary"
          />
        </Stack>
      )}
    </div>
  );
}
